module.exports = __webpack_public_path__ + "img/CP_foto-inicio-ondas.2dd5a779.png";